import { styled } from '@material-ui/styles';
import { colorPrimary } from 'constants/themes';

export const TitlePage = styled('p')((props: any) => ({
    color: props.color || colorPrimary,
    fontSize: props.size || 32,
    fontWeight: 400,
    fontFamily: 'Fraunces_120pt_SuperSoft_Wonky-Regular',
    margin: 0,
    padding: 0,
}));
export const TextNormal = styled('p')((props: any) => ({
    color: props.color || colorPrimary,
    fontSize: 14,
    fontWeight: 400,
    fontFamily: 'PoppinsRegular',
    margin: 0,
    padding: props.padding || 0,
}));
export const Text = styled('p')((props: any) => ({
    color: props.color || colorPrimary,
    fontSize: props.size || '14px',
    fontWeight: props.weight || '400',
    fontFamily: props.font ? props.font : 'PoppinsRegular',
    margin: props.margin || 0,
    padding: props.padding || 0,
    opacity: props.opacity || 1,
}));

export const TextErr = styled('span')({
    color: 'red',
    fontSize: 12,
    fontWeight: 400,
    fontFamily: 'PoppinsRegular',
    marginTop: 4,
    whiteSpace: 'pre-line',
});
